import { render, staticRenderFns } from "./TeamScores.vue?vue&type=template&id=4ab1c5b0&scoped=true"
import script from "./TeamScores.vue?vue&type=script&lang=js"
export * from "./TeamScores.vue?vue&type=script&lang=js"
import style0 from "./TeamScores.vue?vue&type=style&index=0&id=4ab1c5b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab1c5b0",
  null
  
)

export default component.exports